import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgIncomingCall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" {...props}>
    <path
      d="M6.872 6.65 2.318 2M7.83 4l-.718 2.962L4 7.214M14.177 1.35l.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.581.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417a20.5 20.5 0 0 1 1.428-1.948c.514-.465 1.032-.465 1.554 0z"
      fill="none"
      stroke="#919499"
    />
  </svg>
);
const Memo = memo(SvgIncomingCall);
export default Memo;
